import Device from "@/models/Device";

export default class DeviceTransformer {
    transform (data) {
        return new Device(
            data.id,
            data.hardwareId,
            data.simNumber,
            data.enabled,
            data.serialNumber,
            data.firmwareVersion,
            data.dateToCapture,
            data.channelFlag,
            data.customerSim,
            data.automaticVideoDownload,
            data.firstReported,
            data.deviceModelId,
            data.deviceProtocolId,
            data.organizationId,
            data.fleetId,
            data.vehicleId,
        );
    }
}
